/**
 * Badge: pill, 0.75rem 700, no uppercase. Variants subtle-{success|warning|danger|info|neutral|brand}.
 * Prefer <StatusBadge kind=… value=…> (src/components/ui), which maps domain values to these variants.
 */
export const Badge = {
  baseStyle: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1.5,
    h: "1.625rem",
    px: 2.5,
    borderRadius: "full",
    fontFamily: "body",
    fontSize: "0.75rem",
    fontWeight: 700,
    letterSpacing: "0.01em",
    textTransform: "none",
    lineHeight: 1,
    border: "1px solid",
    whiteSpace: "nowrap",
  },
  variants: {
    "subtle-success": { bg: "status.success.bg", color: "status.success.fg", borderColor: "status.success.border" },
    "subtle-warning": { bg: "status.warning.bg", color: "status.warning.fg", borderColor: "status.warning.border" },
    "subtle-danger": { bg: "status.danger.bg", color: "status.danger.fg", borderColor: "status.danger.border" },
    "subtle-info": { bg: "status.info.bg", color: "status.info.fg", borderColor: "status.info.border" },
    "subtle-neutral": { bg: "status.neutral.bg", color: "status.neutral.fg", borderColor: "status.neutral.border" },
    "subtle-brand": { bg: "status.brand.bg", color: "status.brand.fg", borderColor: "status.brand.border" },
  },
  defaultProps: { variant: "subtle-neutral" },
};
